export const AppointmentStatus = {
  Available: 'available',
  Closed: 'closed',
  ReservedPaymentPending: 'reserved_payment_pending',
  ReservedPaymentDone: 'reserved_payment_done',
  Completed: 'completed',
  CancelledByProfessional: 'canceled_by_doctor',
  CancelledByClient: 'canceled_by_client',
  CancelledByAdmin: 'canceled_by_virtualclin_admin',
}
export const appointmentStatusMeta = status => {
  switch (status) {
    case AppointmentStatus.Closed: return { name: 'Fechada', color: 'gray' }
    case AppointmentStatus.ReservedPaymentPending: return { name: 'Pagamento Pendente', color: 'rgb(199,203,62)' }
    case AppointmentStatus.ReservedPaymentDone: return { name: 'Pagamento Realizado', color: 'rgb(86,160,203)' }
    case AppointmentStatus.Completed: return { name: 'Realizada', color: 'rgb(55,148,67)' }
    case AppointmentStatus.CancelledByProfessional: return { name: 'Cancelada', color: 'rgb(196,0,0)' }
    case AppointmentStatus.CancelledByClient: return { name: 'Cancelada', color: 'rgb(196,0,0)' }
    case AppointmentStatus.CancelledByAdmin: return { name: 'Cancelada', color: 'rgb(196,0,0)' }
    default: return { name: 'Disponível', color: 'rgb(215,215,215)' }
  }
}

export const PaymentMethods = {
  CreditCard: 'credit_card',
  BankSlip: 'bank_slip',
  Cash: 'cash',
  PicPay: 'picpay'
}

export const AgendaWorkingTimeType = {
  Manual: 'manual',
  ReadyCare: 'ready_care',
  Syncronized: 'syncronized'
}

export const TeleHealthAppointmentStatus = {
   Completed: 'completed',
   Rescheduled: 'rescheduled',
   PaymentPending: 'payment_pending',
   Canceled: 'canceled',
   BeforeTime: 'before_time',
   ExpiredTime: 'expired_time',
   WaitForDoctor: 'wait_for_doctor',
   WaitForClient: 'wait_for_client',
   InProgress: 'in_progress',
}



// WEBPACK FOOTER //
// ./src/lib/constants.js